export default __webpack_public_path__ + "static/media/store.15afa2b4.png";